import Meeting from './meeting';
import React, {useRef, useEffect} from 'react';

let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

 
//  let el2
function ComingSoon(props) {
  useEffect(() => {

  
 var Application = ( function () {
    var canvas;// = await el2;
    var ctx;
    var imgData;
    var pix;
    var WIDTH;
    var HEIGHT;
    var flickerInterval;

    var init = function () {
        canvas = document.getElementById('canvas');
        ctx = canvas.getContext('2d');
        canvas.width = WIDTH = 700;
        canvas.height = HEIGHT = 500;
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, WIDTH, HEIGHT);
        ctx.fill();
        imgData = ctx.getImageData(0, 0, WIDTH, HEIGHT);
        pix = imgData.data;
        flickerInterval = setInterval(flickering, 30);
    };

    var flickering = function () {
        for (var i = 0; i < pix.length; i += 4) {
            var color = (Math.random() * 255) + 50;
            pix[i] = color;
            pix[i + 1] = color;
            pix[i + 2] = color;
            // console.log(pix)
        }
        ctx.putImageData(imgData, 0, 0);
    };

    return {
        init: init
    };
}());
Application.init();
})
 
//  function Error(props) {
  // const ref = useRef(null);
  // useEffect(() => {
  //   el2 = ref.current;
  //   console.log(el2);
  function routeHome(){
    window.location.href = `/`
  }
  // }, []);
    return (
       
        //   <div className="body-center">
            <>
            {/* <div className="body-grad">&nbsp;</div> */}
            <div className="body-interf-1 center color-grad-blue-border"  id="_404">
                &nbsp;
              <div className="center"><h1>🙄</h1>
              <h3>Currently Unavailable</h3>
              <h2>Coming Soon🤞🏽</h2>
              </div>
              <canvas classNane= "blink" id ="canvas"></canvas>
            </div>
            </>
        

    //   </div>
  );
}
export default ComingSoon; 